module.exports = __webpack_public_path__ + "static/certificate3-3a8d77d6245967b0038191c54a759e2b.jpg";